import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/DemoLandingPage.css';

const DemoLandingPage = () => {
  return (
    <div className="demo-landing-page">
      <div className="hero-section">
        <div className="hero-content">
          <h1>🚀 YouSmart AI Demo</h1>
          <p className="hero-subtitle">
            Teste nossas ferramentas de IA para escrita e correção sem precisar fazer login
          </p>
          <div className="hero-description">
            <p>
              Experimente gratuitamente nossos recursos de inteligência artificial para 
              melhorar sua escrita e corrigir redações do ENEM. Nenhum cadastro necessário!
            </p>
          </div>
        </div>
      </div>

      <div className="features-section">
        <div className="container">
          <h2>🎯 Recursos Disponíveis para Teste</h2>
          
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">✍️</div>
              <h3>Assistente de Escrita com IA</h3>
              <p>
                Escreva artigos e receba feedback em tempo real da nossa IA. 
                Detecta erros gramaticais, sugere melhorias de estilo e 
                oferece análises detalhadas do seu texto.
              </p>
              <div className="feature-highlights">
                <span className="highlight">✅ Correção gramatical</span>
                <span className="highlight">✅ Análise de estilo</span>
                <span className="highlight">✅ Sugestões de melhoria</span>
                <span className="highlight">✅ Marcações inline</span>
              </div>
              <Link to="/demo/article-writer" className="demo-button primary">
                Testar Assistente de Escrita
              </Link>
            </div>

            <div className="feature-card">
              <div className="feature-icon">📝</div>
              <h3>Correção de Redação ENEM</h3>
              <p>
                Sistema completo de correção de redações ENEM com IA. 
                Envie texto digitado ou foto da redação manuscrita e 
                receba análise detalhada com nota e feedback.
              </p>
              <div className="feature-highlights">
                <span className="highlight">✅ Correção automática</span>
                <span className="highlight">✅ Análise por competências</span>
                <span className="highlight">✅ Suporte a imagens</span>
                <span className="highlight">✅ Temas oficiais ENEM</span>
              </div>
              <Link to="/demo/enem-training" className="demo-button primary">
                Testar Correção ENEM
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="how-it-works-section">
        <div className="container">
          <h2>🔧 Como Funciona</h2>
          
          <div className="steps-grid">
            <div className="step">
              <div className="step-number">1</div>
              <h3>Escolha a Ferramenta</h3>
              <p>Selecione entre o assistente de escrita ou correção ENEM</p>
            </div>
            
            <div className="step">
              <div className="step-number">2</div>
              <h3>Escreva ou Envie</h3>
              <p>Digite seu texto ou envie uma foto da sua redação</p>
            </div>
            
            <div className="step">
              <div className="step-number">3</div>
              <h3>Receba Feedback</h3>
              <p>Nossa IA analisa e fornece correções e sugestões detalhadas</p>
            </div>
          </div>
        </div>
      </div>

      <div className="demo-info-section">
        <div className="container">
          <div className="info-card">
            <h3>ℹ️ Informações Importantes</h3>
            <ul>
              <li><strong>Modo Demo:</strong> Suas redações e artigos não serão salvos</li>
              <li><strong>Sem Login:</strong> Não é necessário criar conta para testar</li>
              <li><strong>IA Real:</strong> Usa nossa verdadeira inteligência artificial</li>
              <li><strong>Feedback Completo:</strong> Receba análises detalhadas como na versão completa</li>
              <li><strong>Gratuito:</strong> Teste quantas vezes quiser sem custo</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="cta-section">
        <div className="container">
          <h2>🎉 Pronto para Começar?</h2>
          <p>Escolha uma das ferramentas abaixo e comece a testar agora mesmo!</p>
          
          <div className="cta-buttons">
            <Link to="/demo/article-writer" className="cta-button primary">
              🖊️ Testar Assistente de Escrita
            </Link>
            <Link to="/demo/enem-training" className="cta-button secondary">
              📚 Testar Correção ENEM
            </Link>
          </div>
          
          <div className="back-to-main">
            <Link to="/" className="back-link">
              ← Voltar ao site principal
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemoLandingPage;
